/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-10 15:46:38
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-23 09:46:17
 * @name: 验证
 * @Description: 验证
 * @FilePath: \project\src\nestVue\common\decorators\Validator.js
 * @Author: desktop
 */
import { validator } from "../validator";
import { Message } from "element-ui";
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 设置参数验证
 */
export function Validator(arr, config = {}) {
  return function (target, name, descriptor) {
    let oldValue = descriptor.value;
    descriptor.value = function (req) {
      let validatorResult = { code: 1, msg: '' };
      validatorResult = validator(arr, req);
      if (validatorResult.code === 0) {
        console.error(validatorResult);
        if (config.toastError && validatorResult.toast) {
          Message.error(validatorResult.msg);
        }
      }
      target.ctx.validator = validatorResult;
      return oldValue.call(this, req);
    }
    return descriptor;
  }
}